var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditSendVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 5.71429,
    fill: "#E7EFFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0003 24.8665H10.5771L8.75995 17.9341C8.6737 17.6152 8.49057 17.3333 8.22119 17.2004C7.54893 16.8665 6.80814 16.6008 6 16.4667V16.1998H9.90362C10.4424 16.1998 10.8464 16.6008 10.9138 17.0664L11.8566 22.067L14.2787 16.1998H16.6345L13.0003 24.8665ZM17.9814 24.8665H15.6929L17.5774 16.1998H19.8659L17.9814 24.8665ZM22.8267 18.6008C22.894 18.134 23.2981 17.8671 23.7695 17.8671C24.5103 17.8001 25.3173 17.9341 25.9907 18.2668L26.3948 16.4009C25.7213 16.134 24.9806 15.9999 24.3083 15.9999C22.0871 15.9999 20.4708 17.2004 20.4708 18.8665C20.4708 20.134 21.6157 20.7995 22.4238 21.2004C23.2981 21.6002 23.6348 21.8671 23.5675 22.2669C23.5675 22.8665 22.894 23.1334 22.2218 23.1334C21.4136 23.1334 20.6055 22.9335 19.8659 22.5996L19.4618 24.4667C20.27 24.7995 21.1443 24.9335 21.9524 24.9335C24.443 24.9994 25.9907 23.8001 25.9907 22C25.9907 19.7331 22.8267 19.6002 22.8267 18.6008ZM34 24.8665L32.1829 16.1998H30.2311C29.827 16.1998 29.4229 16.4667 29.2882 16.8665L25.9234 24.8665H28.2793L28.7495 23.6002H31.6441L31.9135 24.8665H34ZM30.5678 18.5338L31.24 21.8001H29.3556L30.5678 18.5338Z",
    fill: "#1360F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditSendVisa);
export default __webpack_public_path__ + "static/media/CreditSendVisa.a033933ee089a7b3c6b4f76545af77b4.svg";
export { ForwardRef as ReactComponent };